import PropTypes from "prop-types";
import { CircularProgress, Typography } from "@material-ui/core";

export default function MonitoramentoPrecoLoading({ classes }) {
  return (
    <div className={classes.loadingWrap} aria-busy="true" aria-live="polite">
      <CircularProgress color="primary" size={48} />
      <Typography className={classes.loadingText} component="p">
        Carregando dados para a coleta…
      </Typography>
    </div>
  );
}

MonitoramentoPrecoLoading.propTypes = {
  classes: PropTypes.object.isRequired,
};
